<div mat-dialog-title class="flex flex-row items-center border-b border-gray-200 px-6 py-2 mb-4">
  <div class="flex flex-col">
    <h3 class="m-0 font-semibold">{{ data.title | translate }}</h3>
    <span class="text-sm text-gray-800">{{ data.subtitle }}</span>
  </div>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>
<mat-dialog-content class="overflow-hidden">
  <ng-container *ngIf="data.type === 'list'">
    <ul class="flex flex-col gap-2">
      <li *ngFor="let item of data.items">
        <span class="text-gray-800">{{ item }}</span>
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="data.type === 'custom'">
    <ng-template [ngTemplateOutlet]="data.customTemplate"></ng-template>
  </ng-container>
</mat-dialog-content>